import React from 'react'
import { UnlockAccountRoute } from '../routes/UnlockAccountRoute'
import { UnlockVerifyCodeRoute } from '../routes/UnlockVerifyCodeRoute'
import { UnlockAccountCallRequiredRoute } from '../routes/UnlockAccountCallRequiredRoute'
import { UnlockSendCode } from '../components/UnlockSendCode'
import { UnlockVerifyCode } from '../components/UnlockVerifyCode'
import { UnlockCallRequired } from '../components/UnlockCallRequired'

type Props = {
  route: UnlockAccountRoute
}

const UnlockAccount = (props: Props) => {
  const { route } = props
  const { username } = route

  const content = () => {
    switch (route.subroute?.path) {
      case UnlockVerifyCodeRoute.path:
        return <UnlockVerifyCode username={username} />
      case UnlockAccountCallRequiredRoute.path:
        return <UnlockCallRequired />
      default:
        return <UnlockSendCode username={username} />
    }
  }

  return (
    <div
      style={{
        width: '100%',
        minHeight: 'calc(100vh - 60px)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        padding: '20px',
      }}
    >
      {content()}
    </div>
  )
}

export default UnlockAccount
